import { createSelector } from 'reselect';

import { TState } from '~/src/store';

const getAddressCheckingResult = createSelector(
    [
        (state: TState) => state.fullBuy.selectedAddress,
    ],
    (selectedAddress) => ({
        isChecked: Boolean(selectedAddress),
        isConnectionAvailable: Boolean(selectedAddress?.isConnectionAvailable),
        isTariffAvailable: Boolean(selectedAddress?.isTariffAvailable),
        newPrice: selectedAddress?.checkingResult &&
            selectedAddress?.checkingResult?.connectionPrice &&
            selectedAddress?.checkingResult.connectionPrice.value &&
            selectedAddress?.checkingResult.connectionPrice.isValid,
    }),
);

export default getAddressCheckingResult;
